import { reactive, toRefs } from 'vue';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'index',
  setup() {
    const data = reactive({
      userToken: localStorage.getItem('tk')
    }); // 数据
    const methods = {}; // 事件

    return {
      ...toRefs(data),
      ...methods
    };
  }
};